import React, {FC} from 'react';

import {useAppSelector} from '../../../../../helpers/reduxHelpers';
import {ApplicationComposerToolbarEntryPointModel} from '../../../../../models/api/applicationEntryPointModel';
import {getHasApplicationComposerToolbarEntryPoint} from '../../../../../store/featureFlags/featureFlagsSelectors';
import {ComposerPanelId, ViewerPanelId} from '../../../../../store/panels/panelStateBase';
import {ApplicationComposerEntryPointButtonContainer} from './applicationComposerEntryPointButtonContainer';
import {ApplicationComposerEntryPointOverflowButtonContainer} from './applicationComposerEntryPointOverflowButtonContainer';

/*
 * Constants.
 */

const overflowingEntryPointsCount = 3;

/*
 * Props.
 */

interface ApplicationComposerEntrypointButtonsProps {
  panelId: ComposerPanelId | ViewerPanelId;
  entryPoints: ReadonlyArray<ApplicationComposerToolbarEntryPointModel>;
}

/*
 * Component.
 */

export const ApplicationComposerEntrypointButtons: FC<ApplicationComposerEntrypointButtonsProps> = (
  props,
) => {
  const {panelId, entryPoints} = props;

  // If they are not on the feature flag, ignore all composer entry points.
  const hasApplicationComposerToolbarEntryPoint = useAppSelector(getHasApplicationComposerToolbarEntryPoint);
  if (!hasApplicationComposerToolbarEntryPoint) {
    return null;
  }

  return (
    <>
      {entryPoints.slice(0, overflowingEntryPointsCount).map((entryPoint) => (
        <ApplicationComposerEntryPointButtonContainer
          key={entryPoint.frameId}
          panelId={panelId}
          entryPoint={entryPoint}
        />
      ))}
      <ApplicationComposerEntryPointOverflowButtonContainer
        entryPoints={entryPoints.slice(overflowingEntryPointsCount)}
        panelId={panelId}
      />
    </>
  );
};
